import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { Provider } from 'react-redux';
import reducers from '../reducers';
import { ModelManager, Constants } from '@adobe/aem-spa-page-model-manager';
import App from './App';
import './MappedComponents';
import Cookies from 'js-cookie';
import aemReactPolyfill from '../../../aem-react-polyfill';
import ppUtilities from '../ppUtilities';
import { VatType } from '../../../utils/ecommerce/vat';

// Solve ModelManager issues on ie 11
aemReactPolyfill.init();

// redux store
const store = createStore(reducers, {}, applyMiddleware(thunk));

window.addEventListener('DOMContentLoaded', (event) => {
	let priceApps = [].slice.call(document.querySelectorAll('.product-pricing-section'));
	let ctID = `ct_${ppUtilities.create_UUID()}`;
	let countryCode = (function getCountryCode() {
		return Cookies.get('omniCoutryCode'); // check if cookie exist.
	})();
	if (!countryCode) {
		ppUtilities.getCountryCode(); // set country code on cookie for later use.
	}
	// VAT variables
	let vatPriceSelection = Cookies.get('hasVatPriceSelection');
	let currentLoc = window.location.href;
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	// VAT :: if VAT price selection is changed from the buy page (heading link)
	if (currentLoc.includes('changePriceVatTo')) {
		const isUnpublishedURl = urlParams.get('wcmmode'); // check if testing env (unpublished)
		const vatSelection = urlParams.get('changePriceVatTo');
		Cookies.set('hasVatPriceSelection', vatSelection);
		window.location.search = isUnpublishedURl && isUnpublishedURl.length ? 'wcmmode=disabled' : '';
	}
	// ProspectId
	if (currentLoc.includes('prosId')) {
		const prosId = urlParams.get('prosId');
		const targetExpDate = new Date().setDate(new Date().getDate() + 7); // storage should expire in 7 days
		const prosIdObj = {
			value: prosId,
			expiry: targetExpDate,
		};
		localStorage.setItem('prosId', JSON.stringify(prosIdObj));
	} else {
		const hasProsObj = JSON.parse(localStorage.getItem('prosId'));
		const timeNow = new Date().setDate(new Date().getDate());
		if (hasProsObj && timeNow > hasProsObj.expiry) {
			localStorage.removeItem('prosId'); // Remove prospectId if older than 7 days
		}
	}

	// isVatPage cookie is set by geoblocking
	let vatCookieSet = Cookies.get('isVatPage');
	// Test if vat cookie is set. There is a possibility that geoblocking is not done yet.
	const tabs = document.querySelectorAll('.cmp-tabs__tab');
	const tabPanelIdToTab = {};
	tabs.forEach((tab) => {
		tabPanelIdToTab[tab?.getAttribute('aria-controls')] = {
			title: tab?.innerHTML,
			id: tab?.getAttribute('id'),
		};
	});
	if (priceApps && priceApps.length) {
		priceApps.forEach((appWrapper, indx) => {
			const tabPanelId = appWrapper?.closest('.cmp-tabs__tabpanel')?.getAttribute('id');
			const tab = tabPanelIdToTab[tabPanelId];
			const tabId = tab?.id;
			const tabTitle = tab?.title;
			let appIdentifier = appWrapper.querySelector('.prc-app-section');
			let appContainer = appIdentifier.querySelector('.prc__pricing-cards');
			/* Begin VAT check */

			if (!vatPriceSelection) {
				// wait for geoblocking to be be done
				if (!vatCookieSet) {
					let waitforVat = setInterval(vatCookieExist, 100);
					let waitT = 0;
					function vatCookieExist() {
						vatCookieSet = Cookies.get('isVatPage');
						if (vatCookieSet || waitT == 80) {
							clearInterval(waitforVat);
							// Redirection begins
							// check if isVAT cookie exist && true
							triggerVATRedirect();

							// Redirection ends
						} else {
							waitT++;
						}
					}
				} else {
					// Redirection begins
					// check if isVAT cookie exist && true
					triggerVATRedirect();
				}

				function triggerVATRedirect() {
					// isVatPage exist && true
					let isVatPage = vatCookieSet === VatType.SELECTION;
					if (isVatPage) {
						// find vat pat
						let vatPagePath = appContainer.getAttribute('data-vat-path');
						// if vat path
						if (vatPagePath) {
							let vatPage = currentLoc.includes('?wcmmode') ? `${vatPagePath}.html?wcmmode=disabled` : `${vatPagePath}`;
							sessionStorage.setItem('vatRedirectPrev', currentLoc);
							// redirect user to vat page && add current url as param
							location.assign(vatPage);
						} else {
							// No VAT Interstitial page path has been authored
							console.warn('[WARN: No VAT Interstitial page path authored and selection is required]');
						}
					}
				}
			}
			/* End VAT check */

			let cartUrl = appContainer.getAttribute('data-carturl');
			let verificationNeeded = appContainer.getAttribute('data-verification-needed');
			let EcommAPI = appContainer.getAttribute('data-ecomm-api');
			let productId = appIdentifier.getAttribute('id');
			let isLast = priceApps.length == indx + 1 ? true : false;
			function render(model) {
				ReactDOM.render(
					<Provider store={store}>
						<App
							key={indx}
							cqChildren={model[Constants.CHILDREN_PROP]}
							cqItems={model[Constants.ITEMS_PROP]}
							cqItemsOrder={model[Constants.ITEMS_ORDER_PROP]}
							cqPath={ModelManager.rootPath}
							EcommAPI={EcommAPI}
							ocationPathname={window.location.pathname}
							verificationNeeded={verificationNeeded}
							cartUrl={cartUrl}
							ctID={ctID}
							totalSections={priceApps.length}
							isLast={isLast}
							order={indx}
							app={appContainer}
							appWrapper={appIdentifier}
							productId={productId}
							store={store}
							tabId={tabId}
							tabPanelId={tabPanelId}
							tabTitle={tabTitle}
						/>
					</Provider>,
					appContainer
				);
			}

			ModelManager.initialize({ path: process.env.REACT_APP_PAGE_MODEL_PATH }).then(render);
		});
	}
});

/*
Ln 58 to ln 111:
if VAT selection
  // pass redirection script

if no VAT selection and no isVatPage
  // wait for geoblocking to set isVAT

if no VAT selection  but isVatPage cookie is set == "selection"
  // go direct to redirection

if no VAT selection  but isVatPage cookie is set == "yes" or "no"
  //By pass VAT code. It is not a VAT selection site.

*/
